import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';

import Box from 'assets/components/box/Box';
import Card from 'assets/components/card/Card';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import UploadDocumentTranslationButton from 'module/productManagement/components/translations/UploadDocumentTranslationButton';
import useProductRefundDocument from './ProductRefundDocument.Hooks';

enum Actions {
  ADD = 'add',
  DELETE = 'delete',
}
export type Verify = Utils.VerifyExtends<
  Module.ProductManagement.ProductRefundDocument.Actions,
  Utils.ValueOf<typeof Actions>
>;
export const productRefundDocumentIndexRoute = productManagementHomeRoute + '/productRefundDocument/:id?';
export default function ProductRefundDocumentIndex() {
  const productRefundDocumentHook = useProductRefundDocument();
  const { lang } = getLocales();

  if (!productRefundDocumentHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <DataProvider
      data={productRefundDocumentHook}
      render={({
        canView,
        isLoadingProductRefundDocument,
        productRefundDocument,
        translatedDocumentList,
        reloadTranslatedDocs,
      }) =>
        canView && (
          <Page
            class={ThemePageList}
            isLoading={isLoadingProductRefundDocument}
            style={{
              pageHeader: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingBottom: 0,
                background: Theme.Color.primary,
                color: Theme.Color.primaryAlt,
                borderBottom: 'none',
              },
            }}
            header={
              <>
                <Box style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                  <Card
                    class={ThemeCardRow}
                    style={{
                      cardMedia: {
                        color: Theme.Color.primary,
                        background: Theme.Color.primaryAlt,
                      },
                    }}
                    media={<Icon class="fas-file-contract" />}
                    info={lang.productRefundDocuments}
                    title={productRefundDocument?.displayInfo?.title}
                    subtitle={productRefundDocument?.documentCategory}
                  />
                  {productRefundDocument && (
                    <Box>
                      <UploadDocumentTranslationButton
                        documentId={productRefundDocument.id}
                        documentType="ProductRefundDocument"
                        translatedDocuments={translatedDocumentList}
                        onFinish={reloadTranslatedDocs}
                      />
                    </Box>
                  )}
                </Box>
              </>
            }
            subHeader={
              <>
                <b style={{ marginRight: 'auto' }} children={lang.productRefundDocuments} />
              </>
            }
          />
        )
      }
    />
  );
}
